module.exports = __webpack_public_path__ + "static/media/loader.b18f9fe6.gif";